import { withNamespaces } from "react-i18next";
import { Card, CardBody } from "reactstrap";
import Knob from "src/modules/3rd-party-management/components/Knob";

const Widget = ({
    title,
    amount,
    icon,
    chart,
    description,
    rate,
    color,
    error,
    t
}) => {
    return (
        <Card>
            <CardBody style={{
                backgroundColor :   color || '#fff'
            }}>
                <div className="d-flex">
                    <div className="overflow-hidden" style={{ flex: "0 0 80%" }}>
                        <p
                            className="text-truncate font-size-14 mb-2"
                            style={{ textTransform: "capitalize" }}>
                            {t(title)}
                        </p>
                        <h4 className={`mb-0 ${error?.hasError ? 'text-danger' : ''}`}>
                            {error?.hasError ? (
                                `${t('Error')}`
                            ) : amount}
                        </h4>
                        {error?.hasError && (
                            <small className="text-danger">
                                {t(
                                    error?.errorStatusCode === 403 ? 
                                    'Please upgrade your plan to access this feature' :
                                    'Unable to load data at this time. Please refresh the page or try again later.'
                                )}
                            </small>
                        )}
                    </div>

                    {icon && (
                        <div
                            className="text-center"
                            dir="ltr"
                            style={{ height: 66 }}>
                            <i
                            className={icon + " font-size-24"}
                            style={{ position: "relative", top: 12, right: 6 }}
                            ></i>
                        </div>
                    )}

                    {chart && chart.show && !error?.hasError && (
                        <div className="text-primary">
                            <Knob
                                value={chart.percent}
                                lineCap="round"
                                height={60}
                                width={60}
                                fgColor="#545B9A"
                                thickness={0.12}
                                readOnly={true}
                            />
                        </div>
                    )}
                </div>
            </CardBody>

                {description && !error?.hasError && (
                    <CardBody className="border-top py-3">
                        <div className="text-truncate">
                            <span className="badge badge-soft-success font-size-11 me-1">
                                <i className="mdi mdi-menu-up"> </i> {rate}
                            </span>
                            <span className="text-muted ms-2">{t(description)}</span>
                        </div>
                    </CardBody>
                )}
        </Card>
    );
}

export default withNamespaces()(Widget);